// ANA-R1-04 — query keys for the taxonomy/v1 AI-finding-model detail reads
// the analysis surface makes to resolve a finding's raw class name to its
// model display name (`useClassDisplayNames`).
//
// These mirror the apps/web `aiModelQueries.ts` `aiModelKeys` shape so the two
// surfaces share TanStack cache entries for the same `getAiFindingModel` read
// (one fetch serves both the AI-model management page and the analysis-surface
// display-name lookup). The key is duplicated rather than imported because
// apps/lyse must not import from apps/web.
export const aiModelKeys = {
  all: ["ai-models"] as const,
  list: ["ai-models", "list"] as const,
  detail: (modelId: string) => ["ai-models", "detail", modelId] as const,
};
